import { MouseEvent } from 'react';

import { ActiveDotProps as RechartsActiveDotProps } from 'recharts';

import { tokens } from '../../../../theme/generated/tokens';

type ActiveDotProps = RechartsActiveDotProps & {
  onClick?: (props: RechartsActiveDotProps, event: MouseEvent) => void;
  testId?: string;
};

// Active chart dot that is seen while hovering on it
export const ActiveDot = ({
  testId = 'chart-active-dot',
  ...props
}: ActiveDotProps) => {
  const { cx = 0, cy = 0, fill, onClick } = props;
  return (
    <g
      data-testid={testId}
      cursor={onClick ? 'pointer' : undefined}
      onClick={onClick ? (e) => onClick(props, e) : undefined}
    >
      <circle
        cx={cx}
        cy={cy}
        r={4.5}
        fill={tokens.theme.bg.structural.surface}
        stroke={tokens.theme.border.structural.neutral}
        strokeWidth={1}
      />
      <circle cx={cx} cy={cy} r={1.5} fill={fill} />
    </g>
  );
};
